import { ArrowUpRight } from 'lucide-react'

export default function OfferLinkArrow() {
	return (
		<ArrowUpRight
			size={12}
			strokeWidth={1.75}
			aria-hidden="true"
			style={{ display: 'inline-block', verticalAlign: 'middle', flexShrink: 0 }}
		/>
	)
}
